import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { fetchBlogList } from "@/utils/blogList.util";
import { findRelatedBlogPosts } from "@/utils/blogLandingBridge.util";

interface RelatedBlogPostsSectionProps {
  /** Landing page keywords to match against blog post titles, e.g. ["whatsapp"]. */
  keywords: string[];
}

// The other half of the blog↔landing-page bridge (see
// blogLandingBridge.util.ts and blogPostSection.component.tsx for the blog
// -> landing direction). Renders nothing if no posts match, rather than a
// generic "no results" state, since this is meant to add relevant reading,
// not fill space.
export default async function RelatedBlogPostsSection({ keywords }: RelatedBlogPostsSectionProps) {
  const blogList = await fetchBlogList().catch(() => []);
  const relatedPosts = findRelatedBlogPosts(keywords, blogList, 3);

  if (!relatedPosts.length) return null;

  return (
    <section className="pb-16 pt-4 sm:pb-24 sm:pt-8">
      <div className="scontainer">
        <h2 className="mb-6 text-center text-2xl font-semibold sm:text-3xl">
          Related Reading
        </h2>
        <div className="grid gap-4 sm:grid-cols-3">
          {relatedPosts.map((post) => (
            <Link
              key={post.blogCode}
              href={`/blogs/${post.blogCode}`}
              className="group flex items-center justify-between gap-3 rounded-xl border border-border bg-white p-5 transition-colors hover:border-primary"
            >
              <span className="font-medium text-secondary">{post.title || post.blogCode}</span>
              <ArrowUpRight className="size-5 shrink-0 text-muted-2-foreground transition-colors group-hover:text-primary" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
